import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AppLayout } from './AppLayout';
import { ExecutionHistoryList } from './ExecutionHistoryList';
import { ExecutionHistoryDetail } from './ExecutionHistoryDetail';

export const ExecutionHistoryPage = () => {
  const navigate = useNavigate();
  const { executionId: urlExecutionId } = useParams<{ executionId?: string }>();
  const [selectedExecutionId, setSelectedExecutionId] = useState<string | null>(urlExecutionId || null);
  // For now, use a default userId - in production, get from auth context
  const userId = 'default-user';

  // Sync state with URL parameter
  useEffect(() => {
    setSelectedExecutionId(urlExecutionId || null);
  }, [urlExecutionId]);

  const handleSelectExecution = (executionId: string) => {
    setSelectedExecutionId(executionId);
    navigate(`/opinions/history/${executionId}`);
  };

  const handleCloseDetail = () => {
    setSelectedExecutionId(null);
    navigate('/opinions/history');
  };

  const handleExecutionNotFound = () => {
    // Fallback to list view if execution doesn't exist
    setSelectedExecutionId(null);
    navigate('/opinions/history', { replace: true });
  };

  return (
    <AppLayout
      pageTitle="Execution History"
      pageDescription="View and search past executions"
    >
      {/* Content */}
      <main data-component="ExecutionHistoryPage" className="flex-1 overflow-hidden">
        <div className="max-w-7xl mx-auto h-full">
          <ExecutionHistoryList
            userId={userId}
            onSelectExecution={handleSelectExecution}
          />
        </div>
      </main>

      {/* Detail Modal */}
      {selectedExecutionId && (
        <ExecutionHistoryDetail
          executionId={selectedExecutionId}
          onClose={handleCloseDetail}
          onNotFound={handleExecutionNotFound}
        />
      )}
    </AppLayout>
  );
};
